import TagManager from "react-gtm-module";
import { GlobalContext } from "contexts/GlobalContext";
import { useContext } from "react";
import { buildDataLayer } from "utils/GtmUtils";

export const LogoutButton = (props: { className?: string }) => {
    const { className = "nav-link" } = props;

    const { logout, addNotification, accountService, setGlobalData } = useContext(GlobalContext);
    const { getGlobalUserData } = accountService;

    return (
        <button
            onClick={() => {
                // log user out
                logout();

                // log gtm
                const dataLayer = buildDataLayer({
                    event: "logout",
                });

                TagManager.dataLayer({
                    dataLayer,
                });

                // notify user
                addNotification({
                    type: "success",
                    title: "Logout successful",
                });

                // clear global data
                getGlobalUserData().then(x => {
                    setGlobalData(x);
                });
            }}
            type="button"
            className={className}
        >
            <span>🚪</span>
            <span className="nav-link__text">Log out</span>
        </button>
    );
};
